import React, { useState, useRef, useEffect } from 'react';
import {
    Box, Avatar, CircularProgress, Menu, MenuItem,
    IconButton, Dialog, DialogTitle, DialogContent,
    DialogActions, Button
} from '@mui/material';
import useApiManager from '../../../utils/Api/apiManager';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const ProfileAvatar = ({ leadDetails, loading }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [pictureUrl, setPictureUrl] = useState(leadDetails?.logoUrl || null);
    const [newPicture, setNewPicture] = useState(null); // local preview before saving
    const [dialogOpen, setDialogOpen] = useState(false);
    const [viewDialogOpen, setViewDialogOpen] = useState(false);
    const inputRef = useRef(null);
    const { post } = useApiManager();

    useEffect(() => {
        if (leadDetails?.logoUrl) {
            console.log("profile: ", leadDetails.logoUrl);
            setPictureUrl(leadDetails.logoUrl);
        }
    }, [leadDetails?.logoUrl]);

    const handleAvatarClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => setAnchorEl(null);

    const handleViewPicture = () => {
        if (pictureUrl) {
            setViewDialogOpen(true);
        }
        handleMenuClose();
    };

    const handleUploadClick = () => {
        inputRef.current?.click();
        handleMenuClose();
    };

    const handleFileChange = (event) => {
        const file = event.target.files?.[0];
        if (file) {
            const preview = URL.createObjectURL(file);
            setNewPicture({ file, preview });
            setDialogOpen(true);
        }
    };

    const handleSavePicture = async () => {
        if (newPicture?.file) {
            const formData = new FormData();
            formData.append('file', newPicture.file); // only append the File object

            const url = `/leads/${leadDetails?.id}/logo`;

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            };

            try {
                await post(url, formData, config);

                // Update the picture preview on success
                setPictureUrl(newPicture.preview);
                setNewPicture(null);
                setDialogOpen(false);
            } catch (error) {
                console.error('Error uploading profile picture:', error);
                // Optional: display error to user
            }
        }
    };


    const handleCancelDialog = () => {
        setNewPicture(null);
        setDialogOpen(false);
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 0 }}>
            {loading ? (
                <CircularProgress />
            ) : (
                <>
                    <IconButton onClick={handleAvatarClick} sx={{ p: 0 }}>
                        <Avatar src={pictureUrl} />
                    </IconButton>

                    <input
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                        ref={inputRef}
                        onChange={handleFileChange}
                    />

                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                        {pictureUrl && (
                            <MenuItem onClick={handleViewPicture}>View Picture</MenuItem>
                        )}
                        <MenuItem onClick={handleUploadClick}>Upload Picture</MenuItem>
                    </Menu>

                    <Dialog open={dialogOpen} onClose={handleCancelDialog}>
                        <DialogTitle>Update Profile Picture</DialogTitle>
                        <DialogContent>
                            {newPicture && (
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Avatar
                                        src={newPicture.preview}
                                        sx={{ width: 120, height: 120 }}
                                        variant="circular"
                                    />
                                </Box>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCancelDialog}>Cancel</Button>
                            <Button variant="contained" onClick={handleSavePicture}>Save</Button>
                        </DialogActions>
                    </Dialog>

                    <Lightbox
                        open={viewDialogOpen}
                        close={() => setViewDialogOpen(false)}
                        slides={[{ src: pictureUrl }]}
                        controller={{ navigation: false }}
                    />
                </>
            )}

            <h3>{loading ? 'Loading...' : `${leadDetails?.firstName || ''} ${leadDetails?.lastName || ''}`}</h3>
        </Box>
    );
};

export default ProfileAvatar;
